<div fxFlexFill fxLayout="column">
  <h1 mat-dialog-title color="warn">
    {{ 'MSG_UPLOAD_WARNING' | translate }}
  </h1>

  <div mat-dialog-content class="mat-subheading-1" fxFlex.lt-sm="20">
    <p class="mat-body">
      {{ 'MSG_CAN_ONLY_UPLOAD_ONE_FILE' | translate }}
    </p>
  </div>

  <div fxFlex="65" class="wrapper">
    <mat-radio-group class="file-option-group" [(ngModel)]="selectedFile">
      <mat-radio-button class="file-option-button" color="primary" *ngFor="let file of listData" [value]="file">
        <span [matTooltip]="file?.fileEntry?.name" matTooltipPosition="after">
          {{ file.relativePath }}
        </span>
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div mat-dialog-actions fxLayout fxLayoutGap="15px" fxLayoutAlign="end end">
    <button type="button" mat-stroked-button (click)="dialogRef.close(false)">
      {{ 'LABEL_CANCEL' | translate }}
    </button>

    <button type="button" mat-raised-button (click)="filterFiles()" cdkFocusInitial color="primary" [disabled]="!selectedFile">
      {{ 'LABEL_OK' | translate }}
    </button>
  </div>
</div>